import { RouteType } from "../../../types/RouteType";

const plantOverviewRoute: RouteType = {
  name: "Company Financial Overview",
  path: "/operations/company-financial-overview",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Company Financial Dashboard",
      enableRefreshButton: true,
      component: () => import("./PlantOverview.Header"),
    },
    body: {
      grayBackground: true,
      component: () => import("./PlantOverview.Body"),
    },
  },
  group: "Operations",
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    console.log(
      "PlantOverview beforeEnter - checking store:",
      rootStore.plantOverviewStore
    );

    // The store will initialize itself via useEffect in the component
    // This prevents timing issues with store creation
    return true;
  },
  onEnter: ({ rootStore }) => {
    // Set up periodic refresh for metrics
    const store = rootStore.plantOverviewStore;
    if (store) {
      console.log("Plant Overview Dashboard entered");
      // Could set up periodic refresh here if needed
      // const intervalId = setInterval(() => {
      //   store.refreshPlantMetrics();
      // }, 60000); // Refresh every minute
    }
  },
  onParamsChange: ({ rootStore, params }) => {
    // Handle any parameter changes if needed
    console.log("Plant overview params changed:", params);
  },
};

export default plantOverviewRoute;
